import React, { SelectHTMLAttributes, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useDividas } from '../../../../../context/DividasContext';
import { apiModulo } from '../../../../../services/api';
import { useAuth } from '../../../../../context/AuthContext';

interface SelectTabulacaoProps extends SelectHTMLAttributes<HTMLSelectElement> {
  isAgendamento: boolean;
  onSelectChange(value: Item): void;
  isOperador?: boolean
  app?: string;
}

interface Item {
  id: string;
  descricao: string;
  permiteagendamento: string;
  finalizador: string;
  telefoneobrigatorio: string;
  tipoacionamento?: string;
}

export const SelectTabulacao = ({ isAgendamento, onSelectChange, isOperador, app, ...rest }: SelectTabulacaoProps) => {
  const { selectedCredor } = useDividas();
  const { cookies } = useAuth()
  const appWS = app ? app : isOperador ? 'ACIONA_OPE' : 'ACIONA_WEB'


  const sitcob = useMutation({
    mutationFn: () =>
      apiModulo.post('/options', {
        codcredor: selectedCredor.credor_crm,
        url: selectedCredor.url_ws,
        legenda: 'SITCOB',
        app: appWS,
        usuario: String(cookies?.user?.id_operador),
      }),
  });

  useEffect(() => {
    sitcob.mutateAsync();
  }, []);

  const tabComAgendamento =
    sitcob.data?.data && sitcob.data.data?.message?.lista?.item?.length > 0
      ? sitcob.data.data?.message?.lista?.item?.filter((item: Item) => item.permiteagendamento === 'true')
      : [];
  const tabSemAgendamento =
    sitcob.data?.data && sitcob.data.data?.message?.lista?.item?.length > 0
      ? sitcob.data.data?.message?.lista?.item?.filter((item: Item) => item.permiteagendamento === 'false')
      : [];
  return (
    <>
      <select
        onChange={(e) => {
          onSelectChange(
            (sitcob.data?.data &&
              sitcob.data.data?.message?.lista?.item?.find((item: Item) => item.id === e.target.value)) ||
            ({} as Item)
          );
        }}
        className="rounded-sm bg-gray-100 p-2 text-gray-600 outline-none"
        {...rest}
      >
        <option value=""></option>
        {sitcob.data?.data &&
          isAgendamento &&
          tabComAgendamento.length > 0 &&
          tabComAgendamento?.map((item: Item) => (
            <option key={item.id} value={item.id}>
              {item.id} - {item.descricao}
            </option>
          ))}

        {sitcob.data?.data &&
          !isAgendamento &&
          tabSemAgendamento.length > 0 &&
          tabSemAgendamento?.map((item: Item) => (
            <option key={item.id} value={item.id}>
              {item.id} - {item.descricao}
            </option>
          ))}
      </select>
    </>
  );
};
